import React from 'react';
import { css } from 'aphrodite';
import styles from './booking-summary-styles';
import { ContentRow } from '../common';
import COLORS from '../../library/colors';
import DirectionsMap from './directions-map';
import Utils from '../../library/utils';

const moment = require('moment');

const BookingSummaryView = (props) => (
  <div className={css(styles.root)}>
    <ContentRow onClick={props.toggleBooking} expandable={true} expanded={props.expanded}>
      <div style={{flex: 1}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <div style={{fontWeight: 'bold'}}>{props.booking.original_route.pickupAddress.postcode} to {props.booking.original_route.dropoffAddress.postcode}</div>
          <div style={{paddingLeft: 4}}>| {props.booking.item.name.toUpperCase()}</div>
          <div style={{flex: 1}}/>
        </div>
        <div style={{height: 12}}/>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <img src={Utils.getVanImgFromSize(props.booking.item.size)} style={{width: 40, height: 28, marginRight: 12}}/>
          <div>{props.booking.item.size} Van, {props.booking.item.liftingPower} Man Team</div>
        </div>
        <div style={{height: 8}}/>
        {props.booking.driver && <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <div>{props.booking.driver.firstName} {props.booking.driver.lastName} | {props.booking.driver.phone}</div>
        </div>}
        <div style={{height: 24}}/>
        <div style={{padding: 4, color: 'grey'}}>Status: {props.booking.status}</div>
        <div className={css(styles.progressBar)}>
          {/*<div className={css(styles.progress)} style={{width: `${props.booking.progress}%`}}/>*/}
        </div>
        <div style={{height: 32}}/>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <div style={{marginRight: 6, width: 12, height: 12, background: COLORS.kgAquaBlue}}/>
          <div>{props.booking.sender.firstName} {props.booking.sender.lastName}</div>
          <div style={{flex: 1}}/>
          <div
            style={{paddingRight: 6, color: 'grey'}}>{moment(props.booking.arrival).utc().local().format('HH:mm A')} |
          </div>
          <div style={{color: 'grey'}}>{moment(props.booking.item.deliverByDate).format('ddd[,] DD MMMM YYYY')}</div>
        </div>
      </div>
    </ContentRow>
    {props.expanded && <div>
      <DirectionsMap
        {...props}
      />
    </div>}
  </div>
);

export default BookingSummaryView;



// WEBPACK FOOTER //
// ./src/components/booking-summary/booking-summary-view.js